<template>
  <div
    v-click-outside="{
      handler: onClickOutside,
      closeConditional,
    }"
    class="side-menu"
    :class="{ 'menu-visible': showMobileMenu }"
  >
    <div
      v-for="item in itemsFiltered"
      :key="item.title"
      :to="item.to"
      active-class="link-active"
      class="nav-button nav-button-mobile"
      @click="goto(item.to)"
    >
      {{ item.title }}
    </div>
    <div
      v-if="isUserLogged"
      active-class="link-active"
      class="nav-button nav-button-mobile"
      @click="logout"
    >
      Log out
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "MobileSideMenu",
  data() {
    return {
      items: [
        { title: "About us", icon: "star", to: "/about" },
        { title: "Catalogue", icon: "build", to: "/catalogue" },
        { title: "Brands", icon: "build", to: "/brands" },
        { title: "News", icon: "explore", to: "/news" },
        { title: "Contact us", icon: "profile", to: "/contact" },
      ],
    };
  },
  computed: {
    ...mapState(["showMobileMenu"]),
    ...mapGetters(["isUserLogged"]),
    itemsFiltered() {
      const links = [...this.items];
      if (this.$source === "ozpartsuk") {
        links.push({ title: "FAQ", icon: "question_answer", to: "/faq" });
      }
      return links;
    },
  },
  methods: {
    ...mapMutations(["setMobileMenu"]),
    logout() {
      this.$store.commit("logOut");
      if (this.$route.name !== "home") {
        this.$router.push("/");
      }
    },
    closeConditional() {
      return this.showMobileMenu;
    },
    onClickOutside() {
      this.setMobileMenu(false);
    },
    goto(where) {
      this.setMobileMenu(false);
      this.$router.push(where);
    },
  },
};
</script>

<style lang="scss" scoped>
.side-menu {
  background-color: var(--red);
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  z-index: 100;
  width: 50vw;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  padding-top: 20px;
}

.menu-visible {
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
}

.nav-button-mobile {
  font-size: 16px;
}
</style>
